<div class="icon-container">
  <mat-icon [ngClass]="primaryColor || ''" class="primary-icon">
    {{ icon }}
  </mat-icon>

  <mat-icon *ngIf="secondaryColor" [ngClass]="secondaryColor" class="secondary-icon">
    {{ icon }}
  </mat-icon>
</div>
